import { render, staticRenderFns } from "./partnerCurrentComponent.vue?vue&type=template&id=5fb15a34&scoped=true&"
import script from "./partnerCurrentComponent.vue?vue&type=script&lang=js&"
export * from "./partnerCurrentComponent.vue?vue&type=script&lang=js&"
import style0 from "./partnerCurrentComponent.vue?vue&type=style&index=0&id=5fb15a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb15a34",
  null
  
)

export default component.exports